import React from 'react';
import ModalV1 from '../modal-v1/index';
import WalkInList from '../walk-in-list/index';
import { useGetParkedCart } from '../../../integrations/react_query/queries';
import { ECart, EQuerykeys } from '../../../models';

type RetrieveSaleModalProps = {
	show: boolean;
	onClose: () => void;
};

export const RetrieveSaleModal = ({ show, onClose }: RetrieveSaleModalProps) => {
	const { isLoading, isError, data } = useGetParkedCart([EQuerykeys.cart, ECart.parked]);

	return (
		<ModalV1
			classes={{ content: 'z-[500]' }}
			show={show}
			onClose={onClose}
			headerAction={
				<div className="text-base font-semibold text-gray-900">
					Retrieve Sales <span className="text-sm text-gray-500">({(data || [])?.length || 0})</span>
				</div>
			}
		>
			{isLoading ? (
				<div className="px-5 py-4 text-center text-gray-500">Loading sales to be retrieved</div>
			) : isError ? (
				<div className="px-5 py-4 text-center text-red-500">There was an error pulling retrieve</div>
			) : (
				<div className="px-5 py-4">
					<WalkInList data={data || []} setShow={onClose} />
				</div>
			)}
		</ModalV1>
	);
};

export default RetrieveSaleModal;
